import type { Trip } from 'contracts/tracking-v2/trips';

export const getTripDeliveryInfo = (invoices: Trip['invoices']) => {
  const deliveredCount = invoices.filter((i) => i.deliveryDate).length;
  const invoicesCount = invoices.length;
  return {
    invoicesCount,
    deliveredCount,
    deliveredRatio: deliveredCount / invoicesCount,
  };
};